import { render, staticRenderFns } from "./CasosSoporteAutorizaciones.vue?vue&type=template&id=9d02c2c8"
import script from "./CasosSoporteAutorizaciones.vue?vue&type=script&lang=js"
export * from "./CasosSoporteAutorizaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports